import {isAllRooms, RoomsFilter} from "../constants/rcn_rooms_filter";

export const getFlatTypeGenitiveLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "nowego mieszkania";
    }

    if (rooms === 1) {
        return "nowej kawalerki";
    }

    if (rooms >= 4) {
        return "nowego mieszkania 4-pokojowego (i więcej)";
    }

    return `nowego mieszkania ${rooms}-pokojowego`;
};

export const getFlatTypeGenitivePluralLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "mieszkań";
    }

    if (rooms === 1) {
        return "kawalerek";
    }

    if (rooms >= 4) {
        return "mieszkań 4-pokojowych (i więcej)";
    }

    return `mieszkań ${rooms}-pokojowych`;
};
import {isAllRooms, RoomsFilter} from "../constants/rcn_rooms_filter";

export const getFlatTypeGenitiveLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "nowego mieszkania";
    }

    if (rooms === 1) {
        return "nowej kawalerki";
    }

    if (rooms >= 4) {
        return "nowego mieszkania 4-pokojowego (i więcej)";
    }

    return `nowego mieszkania ${rooms}-pokojowego`;
};

export const getFlatTypeGenitivePluralLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "mieszkań";
    }

    if (rooms === 1) {
        return "kawalerek";
    }

    if (rooms >= 4) {
        return "mieszkań 4-pokojowych (i więcej)";
    }

    return `mieszkań ${rooms}-pokojowych`;
};
